/**
 * Krymper et bilde før det lastes opp: høyst 2000 punkter på lengste side,
 * som JPEG. Et bilde fra en telefon er ofte 4–8 MB; dette blir et par hundre kB,
 * og opplastingen går fra felt.
 *
 * Bildet tegnes på nytt på et lerret, så det som lå i filen ved siden av selve
 * bildet — også posisjonen telefonen la inn — blir ikke med.
 *
 * Utenfor dekningsmålingen, som `kopier.ts`: dette er lerret og nettleser-API,
 * og prøves ende-til-ende.
 */
const MAKS_SIDE = 2000;

export async function krympBilde(fil: File): Promise<File> {
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(fil.type)) return fil;
  const bilde = await createImageBitmap(fil);
  const skala = Math.min(1, MAKS_SIDE / Math.max(bilde.width, bilde.height));
  const lerret = document.createElement('canvas');
  lerret.width = Math.round(bilde.width * skala);
  lerret.height = Math.round(bilde.height * skala);
  const ctx = lerret.getContext('2d');
  if (ctx === null) return fil;
  ctx.drawImage(bilde, 0, 0, lerret.width, lerret.height);
  bilde.close();
  const blob = await new Promise<Blob | null>((ok) => {
    lerret.toBlob(ok, 'image/jpeg', 0.85);
  });
  if (blob === null) return fil;
  const navn = fil.name.replace(/\.[^.]+$/, '') || 'bilde';
  return new File([blob], `${navn}.jpg`, { type: 'image/jpeg' });
}
